import { useState, useEffect } from "react";
    import { collection, getDocs, addDoc } from "firebase/firestore";
    import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
    import storage,{ db,  } from "../firebase";
import Header from "./Header";
import NavBar from "./NavBar";
import MYProgressBar from "./Progressbar";
import { Button } from "react-bootstrap";
    
    const GalleryImageUploader = () => {
      const [name, setName] = useState("");
      const [description, setDescription] = useState("");
      const [file, setFile] = useState(null);
      const [pbar,startpbar]=useState();
      const [uploadProgress, setUploadProgress] = useState(0);
      const [uimages, usetImages] = useState([]);
      const [add,setadd]=useState(false);
      const [read,setread]=useState(false);
    
      useEffect(() => {
        const fetchImages = async () => {
          try {
            const querySnapshot = await getDocs(collection(db, "gallery"));
            const images = [];
            querySnapshot.forEach((doc) => {
              const { name, description, url } = doc.data();
              images.push({ id: doc.id, name, description, url });
            });
            usetImages(images)
            console.log(images)
          } catch (error) {
            console.error("Error fetching images: ", error);
          }
        };
        fetchImages();

      }, []);
    
      const handleNameChange = (e) => {
        setName(e.target.value);
      };
    
      const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
      };
    
      const handleFileSelect = (e) => {
        setFile(e.target.files[0]);
      };
    
      const handleFileUpload = (e) => {
        startpbar(true);
        e.preventDefault();
        if (file) {
          
          const storageRef = ref(storage, `gallery/${file.name}`);
          const uploadTask = uploadBytesResumable(storageRef, file);
         
          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(
            "state_changed",
            (snapshot) => {
             
              // Get upload progress
              const progress = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
             
              setUploadProgress(progress);
              startpbar("start")
              console.log(pbar)
              console.log("uploaded ",progress)
            },
            (error) => {
              console.error("Error uploading file: ", error);
            },
            async () => {
              // Upload completed successfully, now get download URL
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              console.log("File available at", downloadURL);
              // Save name, description, and downloadURL to Firestore
              try {
                const docRef = await addDoc(collection(db, "gallery"), {
                  name,
                  description,
                  url: downloadURL,
                });
                console.log("Image document written with ID: ", docRef.id);
              } catch (error) {
                console.error("Error adding image document: ", error);
              }
              setUploadProgress(0);
              setName("");
              startpbar("")
              setDescription("");
              setFile(null);
            }
          );
        }
      };
    
      return (
        <div className="w-100">
          <Header />
          <div className="text-center">
            <NavBar />

          <h1>Gallery Part</h1>
          <Button onClick={()=>{setadd(!add);setread(false)}} className="m-1">Create/Add</Button>
      <Button onClick={()=>{setread(!read);setadd(false)}} className="m-1">Read</Button> 
      <Button className="m-1">Update</Button> 
      <Button className="m-1">Delete</Button>

{ add && (<div className="justify-center">

  <form onSubmit={handleFileUpload} className="form row align-center">
    <div className="row justify-content-center">
      <div className="col-5 form-floating mb-3">
        <input required type="text" id="floatingInput" placeholder="Name"  className="form-control" value={name} onChange={handleNameChange} />
        <label  for="floatingInput">Name:</label>
      </div>
    </div>

    <div className="row justify-content-center">
     <div className="col-5 form-floating mb-3">
        <input required className="form-control" id="floatingInput" placeholder="Description" type="text" value={description} onChange={handleDescriptionChange} />
        <label for="floatingInput">Description:</label>
      </div>
    </div>

    <div className="row justify-content-center">
      <div className="col-5">
        <input required class="form-control form-control-lg" type="file" onChange={handleFileSelect} />
      </div>
    </div>

    <div className="row justify-content-center">
      <div className="col">
        <button className="btn btn-outline-success m-2 btn-lg" type="submit">Upload</button>
      </div>
    </div>
  </form>
  {
            pbar==="start"?
            <MYProgressBar
              now={uploadProgress}
              label={uploadProgress + "%"}
            />:
            <div></div>

          }
</div>)}

        { read && (  <div>
          <table className="table text-center">
            <thead>
                <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Pic</th>
                </tr>
                </thead>
                <tbody>
           {
            uimages.map((data)=>(

                
                <tr key={data.id}>
                <td>{data.name}</td>
                <td>{data.description}</td>
                <td><img alt="Modern" src={data.url} width="200" height="100"/></td>
                </tr>
              
             
            ))
           }
           </tbody>
           </table>
          </div>)}
          </div>
        
          </div>
      );
    
};
export default GalleryImageUploader;